import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CalcShell from "../../components/CalcShell";
import CalcField from "../../components/CalcField";
import { formatINR } from "../../utils/format";

const meta = { slug: "rd", emoji: "💳", title: "RD Calculator", desc: "See what your recurring deposit will grow to." };

function RDCalculator() {
  const [monthly, setMonthly] = useState(5000);
  const [rate, setRate] = useState(7);
  const [months, setMonths] = useState(60);

  // RD with quarterly compounding approximated monthly.
  const r = rate / 100 / 4;
  let maturity = 0;
  for (let m = 1; m <= months; m++) {
    const quartersLeft = (months - m + 1) / 3;
    maturity += monthly * Math.pow(1 + r, quartersLeft);
  }
  const invested = monthly * months;
  const interest = maturity - invested;

  return (
    <CalcShell
      meta={meta}
      note={
        <span>
          <strong>About RDs:</strong> A recurring deposit lets you invest a fixed
          sum monthly at a guaranteed rate ideal for disciplined short-term goals.
        </span>
      }
    >
      <Row>
        <Col md={6}>
          <CalcField label="Monthly deposit (₹)" value={monthly} onChange={setMonthly} min={500} max={100000} step={500} prefix="₹" />
          <CalcField label="Interest rate (% p.a.)" value={rate} onChange={setRate} min={1} max={12} step={0.1} suffix="%" />
          <CalcField label="Tenure (months)" value={months} onChange={setMonths} min={6} max={120} step={6} suffix="mo" />
        </Col>
        <Col md={6}>
          <div className="fi-calc-result mb-3">
            <div>Maturity value</div>
            <div className="big">{formatINR(maturity)}</div>
          </div>
          <Row className="g-3">
            <Col xs={6}>
              <div className="fi-stat">
                <div className="num">{formatINR(invested)}</div>
                <small className="text-muted">Total deposited</small>
              </div>
            </Col>
            <Col xs={6}>
              <div className="fi-stat">
                <div className="num">{formatINR(interest)}</div>
                <small className="text-muted">Interest earned</small>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </CalcShell>
  );
}

export default RDCalculator;
